module.exports = __webpack_public_path__ + "img/icon-lego-solution.fa5b4449.svg";